/* istanbul ignore file */
import { hasWindow } from '@pb/helpers';
import {
    TSessionBuyerDetails,
    TBuyerOfferSession,
} from './buyer-offer-session.types';
import {
    initialBuyerAdditionalDetails,
    initialHomeserveOfferDetails,
} from './buyer-offer-session.initial';

export class OfferSessionService {
    storeOfferSession(requestedOffer: TBuyerOfferSession) {
        if (hasWindow()) {
            window.sessionStorage.setItem(
                'buyerOffer',
                JSON.stringify(requestedOffer)
            );
        }
    }

    removeOfferSession() {
        if (hasWindow()) {
            window.sessionStorage.removeItem('buyerOffer');
        }
    }

    getOfferSession() {
        const requestedOffer = hasWindow()
            ? window.sessionStorage.getItem('buyerOffer')
            : null;

        return requestedOffer
            ? (JSON.parse(requestedOffer) as TBuyerOfferSession)
            : null;
    }

    updateMainBuyerDetails(updatedBuyerDetails: TSessionBuyerDetails) {
        const offerSession = this.getOfferSession();
        if (offerSession) {
            const buyerDetails = offerSession.buyers;
            const additionalBuyerDetails = buyerDetails.splice(1);

            const updatedBuyers: TSessionBuyerDetails[] = [
                updatedBuyerDetails,
                ...additionalBuyerDetails,
            ];
            this.storeOfferSession({
                ...offerSession,
                buyers: updatedBuyers,
            });
        }
    }

    updateAdditionalBuyerDetails(
        updatedAdditionalBuyerDetails: TSessionBuyerDetails[]
    ) {
        const offerSession = this.getOfferSession();
        if (offerSession) {
            const mainBuyer = offerSession.buyers[0];

            const updatedBuyers: TSessionBuyerDetails[] = [
                mainBuyer,
                ...updatedAdditionalBuyerDetails,
            ];
            this.storeOfferSession({
                ...offerSession,
                buyers: updatedBuyers,
            });
        }
    }

    getMainBuyerDetails(): TSessionBuyerDetails | null {
        const offerSession = this.getOfferSession();
        if (offerSession) {
            return offerSession.buyers[0];
        }
        return null;
    }

    getAdditionalBuyerDetails(): TSessionBuyerDetails[] {
        const offerSession = this.getOfferSession();
        if (offerSession) {
            return offerSession.buyers.splice(1);
        }
        return [];
    }

    completeOfferAndSanitizeSessionData(offerId: number): void {
        const offerSession = this.getOfferSession();
        if (offerSession) {
            this.storeOfferSession({
                offerId,
                propertyId: offerSession.propertyId,
                offerAmount: offerSession.offerAmount,
                comment: '',
                buyerAdditionalDetails: initialBuyerAdditionalDetails,
                buyers: [],
                homeserveOfferDetails: initialHomeserveOfferDetails,
            });
        }
    }
}
